import { useAppDispatch, useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { useMutation } from 'react-query';

import { setBody } from '../store';

export function useCreateChatFlow() {
  const dispatch = useAppDispatch();
  const { description, name, id: agentId } = useAppSelector(state => state.aiAgentReducer.body);
  const { dataType, type } = useAppSelector(state => state.aiAgentReducer.body);

  const body = {
    name,
    type,
    dataType,
    description,
    original: true,
    ...(agentId && agentId !== 'new' && { id: agentId })
  };

  return useMutation({
    mutationFn: async () => {
      const res = await $api.post(`/v1/chat-flow`, body);

      return res.data;
    },
    onSuccess: res => {
      dispatch(setBody({ id: res?.data?.id }));
    }
  });
}
